import { useMutation, useQueryClient } from 'react-query';
import { enqueueSnackbar } from 'notistack';

import { postVulOnMap } from 'api/InteractiveMap/postVulOnMap';

const usePostVulOnMap = () => {
  const queryClient = useQueryClient();

  const {
    isSuccess,
    mutate: createVul,
    isLoading,
  } = useMutation(postVulOnMap, {
    onSuccess: () => {
      queryClient.invalidateQueries('vulnerabilities');
      enqueueSnackbar('Vulnerability was created successfully', { variant: 'success' });
    },
  });

  return {
    isSuccess,
    createVul,
    isLoading,
  };
};

export default usePostVulOnMap;
